// Brand constants
export const BRAND = {
  burgundy: "#D62828",
  burgundyDark: "#A91D1D",
  coral: "#2E78C5",
  coralLight: "#E3F0FB",
};

export const COMPANY_PHONE = "(405) 351-7119";
export const COMPANY_PHONE_TEL = "+14053517119";
export const CALENDLY_URL = "https://calendly.com/thornmod1/30min";
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_referral-portal-11/artifacts/y6m4jdk1_media_1%2B-%2B2026-03-12T140844.703-1920w.webp";

export const STATUS_LABELS = {
  new: "New",
  in_review: "In Review",
  placed: "Placed",
  paid: "Paid",
  declined: "Declined",
};

export const TIER_OPTIONS = [
  { val: null, label: "Unset", color: "#9E9E9E" },
  { val: 1, label: "Tier 1", color: "#2E7D32" },
  { val: 2, label: "Tier 2", color: "#E65100" },
  { val: 3, label: "Tier 3", color: "#C62828" },
];
